import rcPlacements from '../../../lib/rc-components/tooltip/placements';
import getPlacements, { getOverflowOptions } from '../../../lib/tooltip/placements';
export { rcPlacements, getOverflowOptions, getPlacements as default, };
